/// <amd-module name="SuiteCommerce.LookBook.LookBook.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.LookBook.View", ["require", "exports", "suitecommerce_lookbook_lookbook.tpl", "SuiteCommerce.LookBook.Common.Configuration", "Backbone", "SuiteCommerce.LookBook.Instrumentation", "jQuery", "BxSlider"], function (require, exports, lookBookTpl, Configuration_1, Backbone_1, Instrumentation_1, jQuery) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookBookView = void 0;
    var LookBookView = /** @class */ (function (_super) {
        __extends(LookBookView, _super);
        function LookBookView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = lookBookTpl;
            _this.title = '';
            _this.metaKeywords = '';
            _this.metaDescription = '';
            _this.application = options.application;
            _this.model = options.model;
            _this.title = _this.model.getTitle();
            _this.metaKeywords = _this.model.getMetaKeywords();
            _this.metaDescription = _this.model.getMetaDescription();
            _this.setupListeners();
            return _this;
        }
        LookBookView.prototype.setupListeners = function () {
            var _this = this;
            this.on('afterViewRender', function () {
                _this.slider = _this.$('[data-slider]').bxSliderNew({
                    nextText: '<a class="lookbook-gallery-next-icon"></a>',
                    prevText: '<a class="lookbook-gallery-prev-icon"></a>',
                    touchEnabled: true,
                    auto: true,
                    pager: true,
                });
                jQuery(function () {
                    _this.reloadSlider();
                });
            });
        };
        LookBookView.prototype.reloadSlider = function () {
            if (this.slider && this.slider.length > 0) {
                this.slider.reloadSlider();
            }
        };
        LookBookView.prototype.getBreadcrumbPages = function () {
            return [
                {
                    text: this.model.getName(),
                    href: '/' + this.model.getUrlComponent(),
                },
            ];
        };
        LookBookView.prototype.logShowSpecificLookBook = function () {
            if (this.model.getLooks().length > 0) {
                var logUsage = Instrumentation_1.default.getLog('Show landing page of lookbook specific');
                logUsage.setParameters({
                    activity: 'Show landing page of lookbook specific',
                    instanceCount: this.model.getLooks().length
                });
                logUsage.submit();
            }
        };
        LookBookView.prototype.getContext = function () {
            return {
                align: this.model.getAlign(),
                displayLookBookSlide: Configuration_1.Configuration.displayLookBookSlide,
                image: this.model.getImage(),
                longdesc: this.model.getLongDesc(),
                looks: this.model.getLooks(),
                name: this.model.getName(),
                shortdesc: this.model.getShortDesc(),
                textcolor: this.model.getTextColor(),
                urlcomponent: this.model.getUrlComponent(),
            };
        };
        return LookBookView;
    }(Backbone_1.View));
    exports.LookBookView = LookBookView;
});
